import { ScaleLinear } from 'd3-scale';

import { BarRounded } from '@visx/shape';
import { Group } from '@visx/group';

import { CategoryScale, CategoryValue } from './types';

type BarSeriesProps = {
  data: { categoryValue: CategoryValue; value: number | null }[];
  fillColor: string;
  fillOpacity?: number;
  valueScale: ScaleLinear<number, number>;
  categoryScale: CategoryScale;
  barRadius?: number;
  barWidth?: number;
  x?: number;
  y?: number;
};

export const BarSeries = (props: BarSeriesProps) => {
  const {
    data,
    fillColor,
    fillOpacity = 1,
    valueScale,
    categoryScale,
    barWidth = 10,
    barRadius = 5,
  } = props;

  return (
    <Group>
      {data.map(({ categoryValue, value }, idx) => {
        if (value === null) {
          return null;
        }
        const isNegative = value < 0;
        const x = (categoryScale(categoryValue.formatted) ?? 0) + (props.x ?? 0);

        return isNegative ? (
          <BarRounded
            key={idx}
            x={x}
            y={valueScale(0) + (props.y ?? 0)}
            width={barWidth}
            height={valueScale(value) - valueScale(0) + (props.y ?? 0)}
            fill={fillColor}
            fillOpacity={fillOpacity}
            radius={barRadius}
            bottom
          />
        ) : (
          <BarRounded
            key={idx}
            x={x}
            y={valueScale(value) + (props.y ?? 0)}
            width={barWidth}
            height={valueScale(0) - valueScale(value) + (props.y ?? 0)}
            fill={fillColor}
            fillOpacity={fillOpacity}
            radius={barRadius}
            top
          />
        );
      })}
    </Group>
  );
};
